import { memo } from 'react';
import { useNavigation } from '@betty/navigation';
import { Box, Button, InfoImage, ScrollView } from '@betty/moonlight';
import { PaymentMethodVerificationSuccessProps } from './PaymentMethodVerificationSuccess.types';

function PaymentMethodVerificationSuccess({
  hasMultiplePayments,
}: PaymentMethodVerificationSuccessProps) {
  const navigation = useNavigation();

  return (
    <ScrollView contentContainerStyle={{ minHeight: '100%' }}>
      <InfoImage
        flex={1}
        image="common.success"
        titleNS="wallet"
        titleKey="paymentMethodVerificationSuccessTitle"
        descriptionNS="wallet"
        descriptionKey="paymentMethodVerificationSuccessDescription"
        paddingTop="space-800"
      >
        <Box
          flex={1}
          gap="space-400"
          justifyContent="flex-end"
          paddingBottom="safe-area-inset-bottom"
        >
          {hasMultiplePayments && (
            <Button
              locNS="wallet"
              locKey="paymentMethodVerificationVerifyAnotherCard"
              size="large"
              onPress={navigation.goBack}
            />
          )}
          <Button
            variant="secondary"
            locNS="common"
            locKey="close"
            size="large"
            onPress={navigation.getParent()?.goBack}
          />
        </Box>
      </InfoImage>
    </ScrollView>
  );
}

export default memo(PaymentMethodVerificationSuccess);
